"use strict";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);

import SimpleBar from "simplebar";
import Swiper from "swiper/bundle";

// window.addEventListener("resize", swiper);
window.addEventListener("DOMContentLoaded", () => {
  swiper();
});
function swiper() {
  const swiper = new Swiper(".office .swiper", {
    loop: true,
    slidesPerView: 1,
    speed: 25000, // ループの時間
    allowTouchMove: false,
    autoplay: {
      delay: 5, // speedの倍時間と合わせることで止まらせない
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    breakpoints: {
      960: {
        slidesPerView: 3,
      },
    },
  });
}
//モーダル内のスライド
const swiperInterview = new Swiper(".interview-modal .swiper", {
  loop: true,
  slidesPerView: 1, // 一度に表示する枚数
  // slidesPerView: "auto",
  centeredSlides: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".interview-modal__next",
    prevEl: ".interview-modal__prev",
  },
});
//モーダル
const interviewItem = document.querySelectorAll(".interview__item");
for (let i = 0; i < interviewItem.length; i++) {
  interviewItem[i].addEventListener(
    "click",
    (e) => {
      const itemNum = interviewItem[i].dataset.num;
      swiperInterview.slideTo(itemNum);
      gsap
        .timeline({
          defaults: {
            ease: "power2.out",
          },
        })
        .to("body", { overflow: "hidden", duration: 0 }, 0)
        .to(
          ".interview-modal__scroll",
          { overscrollBehavior: "contain", duration: 0 },
          0
        )
        .to(".interview-modal", { zIndex: 999, duration: 0 }, 0)
        .to(".interview-modal", { opacity: 1, duration: 0.6 }, 0.5);
      // console.log(itemNum);
    },
    false
  );
}
const modalClose = document.querySelectorAll(".js-modal-close");
modalClose.forEach((target) => {
  target.addEventListener(
    "click",
    (e) => {
      let current = e.currentTarget;
      let parent = current.closest(".interview-modal__inner");
      gsap
        .timeline({
          defaults: {
            ease: "power2.out",
          },
        })
        // .to(parent, { opacity: 0, duration: 0.6 }, 0)
        // .to(parent, { zIndex: -100, duration: 0.01 }, 0.61)
        .to("body", { overflow: "auto", duration: 0 }, 0)
        .to(
          ".interview-modal__scroll",
          { overscrollBehavior: "auto", duration: 0 },
          0
        )
        .to(".interview-modal", { zIndex: -100, duration: 0.1 }, 0)
        .to(".interview-modal", { opacity: 0, duration: 0.2 }, 0);

      modalScrollTop();
    },
    false
  );
});
const hoge = document.querySelectorAll(".js-scroll-reset");
hoge.forEach((target) => {
  target.addEventListener(
    "click",
    (e) => {
      modalScrollTop();
    },
    false
  );
});
//////
// modal内共通
////
function modalScrollTop() {
  let modalScrollItem1 = document.querySelectorAll(".simplebar-offset");
  for (let i = 0; i < modalScrollItem1.length; i++) {
    modalScrollItem1[i].scrollTo(0, 0);
  }
  let modalScrollItem2 = document.querySelectorAll(".simplebar-wrapper");
  for (let i = 0; i < modalScrollItem2.length; i++) {
    modalScrollItem2[i].scrollTo(0, 0);
  }
  let modalScrollItem3 = document.querySelectorAll(
    ".simplebar-content-wrapper"
  );
  for (let i = 0; i < modalScrollItem3.length; i++) {
    modalScrollItem3[i].scrollTo(0, 0);
  }
}

/******************
 * ホバー
 ******************/
const hoverItem = document.querySelectorAll(".js-hover-item");
hoverItem.forEach((item, index) => {
  const targetNum = document.querySelectorAll(".interview__num");
  const targetImg = document.querySelectorAll(".interview__img");

  item.addEventListener("mouseenter", () => {
    //全体リセット
    for (let i = 0; i < targetNum.length; i++) {
      targetNum[i].classList.remove("is-active");
    }
    for (let i = 0; i < targetImg.length; i++) {
      targetImg[i].classList.remove("is-active");
    }
    //num
    targetNum[index].classList.add("is-active");

    //img
    targetImg[index].classList.add("is-active");
  });
});

/******************
 * 仙台オフィスとは(3つのモチーフ)
 ******************/
const slideinAnime = document.querySelectorAll(".js-slidein-anime");
const officeItem = document.querySelectorAll(".office__item");
slideinAnime.forEach((item, index) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      for (let i = 0; i < officeItem.length; i++) {
        officeItem[i].classList.add("is-active");
      }
    },
  });
});
///@@@ スライドアニメ改修中
//app.jsへ
// const ttlAnime = document.querySelectorAll(".ttl-slide span");
// const ttlSpanAnime = document.querySelectorAll(".ttl-slide span");
// console.log(ttlSpanAnime.length);
// ttlAnime.forEach((item, index) => {
//   ScrollTrigger.create({
//     trigger: item,
//     start: "top 75%",
//     once: true,
//     onEnter: () => {
//       item.classList.add("is-active");
//       // for (let i = 0; i < ttlSpanAnime.length; i++) {
//       //   ttlSpanAnime[i].classList.add("is-active");
//       // }
//     },
//   });
// });

// (function loop() {
//   console.log("hello");
//   setTimeout(loop, 1000);
// })();

/******************
 * サイドmenu
 ******************/
//@@@ 共通Jsへ
// window.addEventListener("scroll", function () {
//   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//   const section = document.querySelectorAll(".js-nav-section");
//   const navTxt = document.querySelectorAll(".side-nav__item");

//   const sectionY = [];

//   for (let i = 0; i < section.length; i++) {
//     const sectionRect = section[i].getBoundingClientRect();
//     const sectionTop = sectionRect.top + window.pageYOffset;
//     sectionY.push(sectionTop);
//     if (sectionY[i] - 120 < scrollTop) {
//       if (navTxt[i].previousElementSibling) {
//         navTxt[i].previousElementSibling.classList.remove("is-active");
//       }
//       if (navTxt[i].nextElementSibling) {
//         navTxt[i].nextElementSibling.classList.remove("is-active");
//       }
//       navTxt[i].classList.add("is-active");
//     }
//   }
// });

/******************
 * パララックス
 ******************/
// @@@ 共通へ
// gsap.utils.toArray(".js-parallax").forEach((wrap) => {
//   const y = wrap.getAttribute("data-y") || -100;

//   gsap.to(wrap, {
//     y: y,
//     scrollTrigger: {
//       trigger: wrap,
//       start: "top bottom",
//       end: "bottom top",
//       scrub: 0.2,
//       //markers: true
//     },
//   });
// });

//////
const iconAnimeTrigger = document.querySelector(".js-icon-anime-trigger");
const iconAnime = document.querySelector(".js-icon-anime");

function hover() {
  gsap
    .timeline({
      defaults: {
        ease: "power2.out",
      },
    })
    .to(
      `.js-icon-anime`,
      {
        css: {
          className: "sendai-entry__icon js-icon-anime is-active",
        },
        duration: 0,
      },
      0
    );
}
function hoverLeave() {
  gsap
    .timeline({
      defaults: {
        ease: "power2.out",
      },
    })
    .to(
      `.js-icon-anime`,
      {
        css: {
          className: "sendai-entry__icon js-icon-anime",
        },
        duration: 0,
      },
      0
    );
}

iconAnimeTrigger.addEventListener("mouseenter", () => hover());
iconAnimeTrigger.addEventListener("mouseleave", () => hoverLeave());

// start();
function start() {
  gsap
    .timeline({
      defaults: {
        ease: "power2.out",
      },
    })
    .to(
      ".js-ttl-path-anime1",
      { transform: "translateY(0px)", duration: 0.5 },
      0.5
    )
    .to(".js-ttl-path-anime1", { opacity: 1, duration: 0.3 }, 0.5)

    .to(
      ".js-ttl-path-anime2",
      { transform: "translateY(0px)", duration: 0.5 },
      0.6
    )
    .to(".js-ttl-path-anime2", { opacity: 1, duration: 0.3 }, 0.6);
}
